import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaChannels'
import { environmentRoute } from 'pages/NWPlatform'
import { Structure } from 'pages/NWPlatform/MediaChannels/Structure'

export const mediaChannelsRoute = createRoute({
  getParentRoute: () => environmentRoute,
  path: StaticRouteParameter.MEDIA_CHANNELS,
  loader: () => ({
    crumb: t('entity:publishing.mediaChannel', { count: 2 }),
  }),
})

export const mediaChannelsOverviewLayoutRoute = createRoute({
  getParentRoute: () => mediaChannelsRoute,
  id: 'mediaChannelsOverviewLayout',
  component: Structure,
})

type MediaChannelsOverviewSearch = {
  query?: string
}

export const mediaChannelsOverviewRoute = createRoute({
  getParentRoute: () => mediaChannelsOverviewLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: MediaChannelsOverviewSearch) => ({
    ...(search.query && { query: search.query }),
  }),
})
